import React, { Component } from 'react';

class Slide extends Component {
  getStyles() {
    const { width } = this.props;

    return {
      flexShrink: '0',
      flexGrow: '0',
      flexBasis: `${width}%`,
      width: `${width}%`,
      maxWidth: `${width}%`,
      boxSizing: 'border-box',
    };
  }

  render() {
    const { child } = this.props;
    const styles = this.getStyles();

    return <div style={styles}>{child}</div>;
  }
}

export default Slide;
